import React from 'react';
import { Card } from 'antd';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import map from 'lodash/map';
import toString from 'lodash/toString';
import isEqual from 'lodash/isEqual';

import useFilterContentByType from '../../../hooks/useFilterContentByType';
import ContentToolbar from '@components/snippets/ContentToolbar';
import ContentFilter from '@components/snippets/ContentFilter';
import PlaylistCard from '../PlaylistCard';
import { useTranslation } from 'react-i18next';
import uniqueId from 'lodash/uniqueId';

const Content = React.memo(
  function Content({
    content = [],
    tabList,
    sort,
    onChange,
    onSort,
    onSearch,
  }) {
    const { t } = useTranslation();

    return (
      <Card
        className="playlist__content playlist-content"
        title={<div className="playlist-content__title">{t('content')}</div>}
        bordered={false}
        tabList={tabList}
        onTabChange={onChange}
        extra={<ContentToolbar className="playlist-content__toolbar" />}
      >
        <ContentFilter sort={sort} onSearch={onSearch} onSort={onSort} />
        <Droppable droppableId="droppable" isDropDisabled={true}>
          {(provided, snapshot) => (
            <div
              className="position-relative"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              <div className="playlist__cards">
                {map(content, (item, index) => (
                  <Draggable
                    key={`drop-${toString(item.id)}`}
                    draggableId={`drop-${toString(item.id)}`}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <>
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <PlaylistCard {...item} />
                        </div>
                        {snapshot.isDragging && <PlaylistCard {...item} />}
                      </>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            </div>
          )}
        </Droppable>
      </Card>
    );
  },
  (prevProps, nextProps) => {
    return isEqual(prevProps.content, nextProps.content);
  }
);

Content.whyDidYouRender = true;

export default Content;
